import React from 'react';

import Dropdown from '#/components/basic/inputs/Dropdown';

interface Props {
  onChange: (value: 'byChange' | 'byROI') => void;
  selected: 'byChange' | 'byROI';
}

export default function TriggerDropdown({ onChange, selected }: Props) {
  return (
    <Dropdown
      noBorder
      slim
      selected={selected}
      onChange={onChange}
      options={[
        {
          label: 'Trigger by Change %',
          value: 'byChange',
        },
        {
          label: 'Trigger by ROI %',
          value: 'byROI',
        },
      ]}
    />
  );
}
